export default __webpack_public_path__ + "static/media/gaLogoCopy.ef82ec8f.png";